module.exports = __webpack_public_path__ + "img/step3-detail_bottoom2.e685de3c.png";